import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import style from './button.scss';
import omit from 'lodash/omit';

@CSSModules(style, { allowMultiple: true })
export default class Button extends Component {
  static defaultProps = {
    type: 'default',
    size: 'default',
    submit: false
  };

  render() {
    const styles = ['root', `type-${this.props.type}`, `size-${this.props.size}`, this.props.disabled ? 'disabled' : ''];

    if (this.props.block) styles.push('block');
    if (process.muhimma.indexOf(process.target[0]) !== -1) styles.push('muhimma')
    const props = omit(this.props, 'type', 'size', 'loading');
    
    return (
      <button
        type={this.props.submit ? 'submit' : 'button'}
        className={`Button ${props.className}`}
        styleName={styles.join(' ')}
        onClick={props.onClick}
        style={{...props.style}}
      >
        {!this.props.loading && this.props.children}
        {this.props.loading && <div styleName="loader"></div>}
      </button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/button.js